module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.dropdownClasses
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    attrs: {
      "type": "hidden",
      "name": _vm.name
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "default text"
  }, [_vm._v(_vm._s(_vm.placeholder))]), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu dropdown_menu"
  }, [_vm._t("default"), _vm._v(" "), _vm._l((_vm.items), function(option) {
    return _c('div', {
      staticClass: "item",
      attrs: {
        "data-value": option.id,
        "data-text": option.name
      }
    }, [_vm._v(_vm._s(option.name))])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-73b6778c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/croud-vue-semantic/src/FormDropdown.vue
// module id = 1462
// module chunks = 1